module.exports = {
  db30fe19588fd8c4: "YYYY 年",
  "8629fc47adf62a40": "MM 月",
  "5b6f28d3282af680": "切换语言",
  "9fcdcb3a067903d8": "中文",
  "9144ddc68d05d528": "开始时间",
  "8b5d709462c8e71e": "结束时间",
  de50cdb3c301d44e: " 至 ",
  "11dc49914b8c56d2": "YYYY年",
  "0e5ea5d9d98d17e4": "                  生成中",
  "95d22c733b3a558b": "还没有导出数据哦！",
  "245883c80f181c4a": "下载",
  "4b3340f7872b411f": "取消",
  ceb0f1f17c8c088a: "重试",
  "8a723a5ad03fbef7": "以全新的视角可视化呈现您的数据，揭秘每一个数据流背后隐藏的故事内容",
  "79f45f61305a0694": "数据中心",
  "82adf873c2aef782": "不同渠道背后客户的反馈内容，了解客户说了什么",
  cd613ea5c3daa178: "文本分析",
  "2bcd2acb33ab9226": "为非结构化的数据带来深入的洞察，发挥数据的价值",
  "2c7ee80c60ede727": "行动记录",
  "58f6db165d04ad25": "及时响应、流转并解决问题，分析到行动的落地闭环",
  "0df7926026e8e4e3": "行动中心",
  ae1d807fd0454199: "预警系统",
  "4a225c64927330be": "及时预警客诉，能有效地帮助你防止差评的产生，进而提升客户的满意和复购意愿",
  "2bc8f2a83dcff037": "配置中心",
  "16ffc39911362949": "高度开放的自定义模块，提供强力的可视化工具，从AI到BI的无缝衔接",
  c5bda3e67870893b: "语音分析",
  ee34d8dc6f215415: "华客AI，将每一通宾客电话都变成提升客户体验的指标",
  "5da3515674304897": "舆情管理",
  a3c01440cba1fd06: "全渠道点评数据分析，一站式点评回复系统",
  f6e62f9642018cbb: "首页",
  "65754b79e7c41c2e": "纵观全局，实时分析关键指标，AI辅助诊断问题点",
  "1c4cb97f3f9338d2": "服务质检",
  b52df67306a35e1e: "以客户之声做反馈渠道，了解酒店每天发生的事情",
  aa7e6c204c751cfa: "退出登录",
  daaaeb1b7b22b126: "提示",
  "204ffab8a6e01870": "确定",
  "99c6de19eee99cbd": "我是标题",
  d5001524a5b363be: "                客服系统",
  c95e288930c2d650: "                联系我们",
  "2a0c41705beab1c4": "                企业设置",
  "03bc57fa724ffe80": "                我的账号",
  b1a35339ebce4e70: "应用中心",
  cc42c6e70c289f19: "企业设置",
  b19febc08994f009: "我的账号",
  b4bced00356095dc: "退出",
  c066ca9e9373f4d4: "在线咨询",
  "07c9d82ce42fdb94": "联系我们",
  dc1be1aee87ddbbf: "添加专属客服",
  f3e283a3944775ff: "一对一为您答疑解惑",
  "55e274a683da9316": "咨询电话：400-869-2990",
  "1c8bd65646e50fff": "返回今天",
  b1b93a04399891da: "请输入文本内容",
  ae761dce162dc46e: "倍数",
  "29adff17ec123b86": "排队中",
  "2b106e1cf0ecb720": "生成中",
  "720255ed1dcefd87": "                消息中心",
  "4672a61500412430": "系统选择",
  e6a250894a04db4c: "详情",
  "8bc1785cb7e61665": "数据明细，助力酒店集团一查到底，深度聚焦问题，提升集团管控能力",
  "8f25571b6140639f": "分析看板",
  c935c1d59ee52208: "灵活的数据分析看板，自由定制，满足集团/事业部多种数据分析需求",
  "80ca7ecf9313ef17": "市场分析",
  "803f12f69cd31b8c": "犀利洞察和预警市场变化，助力企业随机应变，取得先机",
  "877baf13a06ce174": "质量微循环",
  e1c9ff1d345d58c5: "用检查表加工作流的方式赋能门店的MOD、TQM检查。",
  "5e1466065999ca19": "单店操作管理",
  "37b469bf39d0fdd2": "门店/帐号维度的访问数据统计，帮助管理者及时洞察产品使用情况",
  f4c19062aa935c68: "客户管理",
  cd82b93f3e8f252b: "全渠道数据聚合的客户画像管理",
  c3525eb110db58aa: "更多",
  db956d943d09abdb: "立即免费体验",
  "28a2281262eeb577": "入住确认、续住确认、满意度回访开箱即用",
  "0ff4257c11825f37": "智能外呼",
  de6d10e5acd01f70: "您好，",
  b25692821fba7ab1: "返回旧版导航",
  "77c1d7b636b40db9": "您是否确认返回旧版导航使用？",
  "5556ba0c8eacf558": "使用新版导航",
  "022a3d7c171bb839": "是否确认使用新版导航"
}
